import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {OfferNotesPage} from "./-page/offer-notes.page";
import {OfferNotesPending} from "./-page/offer-notes.pending";
import {offerNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/offers/$offerId/notes/")({
  component: RouteComponent,
  pendingComponent: OfferNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => offerNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {offerId} = Route.useParams();

  return <OfferNotesPage offerId={offerId} />;
}
